import { useTranslation } from "react-i18next";
import { services } from "../data/services";
import "../styles/InfoSections.css";

const Services = () => {
  const { t, i18n } = useTranslation();
  const items = services[i18n.language] ?? services.tr;

  return (
    <section id="hizmetlerimiz" className="info-section">
      <h2 className="info-section-head">{t("servicesHeader")}</h2>
      <div className="info-grid">
        {items.map((service) => (
          <div className="info-item" key={service.name}>
            <h3 className="info-item-head">{service.name}</h3>
            <p className="info-item-prg">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
export default Services;
